module.exports = __webpack_public_path__ + "static/img/team2-01.ea59e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team2-01.jpg
// module id = 9Cry
// module chunks = 1